import styled from 'styled-components';

import EditorSaveButtonComponent from './EditorSaveButton';

const EditorSaveButton = styled(EditorSaveButtonComponent)`
  margin-left: 8px;
`;

export default EditorSaveButton;
